import CONSTANT from "../../constants/Constant";
import { isMobile } from "react-device-detect";
import React from "react";
import { useSelector } from "react-redux";
import { getIndexOfCurrentGroup } from "./EditAssessmentUtils";
import useEditAssessmentHeaderAndFooter from "./hooks/useEditAssessmentHeaderAndFooter";
import './EditAssessmentQuestionFooter.scss';

const EditAssessmentQuestionFooter = () => {
    const { handleOnClickNextBtn, handleOnClickPrevBtn, handleOnClickSubmit } = useEditAssessmentHeaderAndFooter();
    const editAssessmentGroup = useSelector(state => state.editAssessment);
    const groups = editAssessmentGroup?.groups;

    const baseData = editAssessmentGroup?.baseData || {};
    const currentGroupId = baseData?.currentGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
    const currentGroupIndex = getIndexOfCurrentGroup(groups, currentGroupId);
    const currentSubGroupIndex = baseData?.currentSubGroupIndex || 0;
    const isReportAvailable = baseData?.isReportAvailable || false;

    const currentGroup = groups[currentGroupIndex];
    const subGroups = currentGroup?.subGroups || [];
    const currentSubGroup = subGroups[currentSubGroupIndex];
    const currentSubGroupQuestions = currentSubGroup?.questions;

    const groupIdsWillHaveSubmitBtn = [
        CONSTANT.ASSESSMENT_GROUP.MEDICAL_HISTORY.key,
        CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key,
        CONSTANT.ASSESSMENT_GROUP.OUTCOME_ASSESSMENT.key,
        CONSTANT.ASSESSMENT_GROUP.ATHLETE.key
    ]

    return (
        <>
            {(
                (subGroups && subGroups.length > 0) ||
                (currentGroup?.groupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key)
            ) && (
                <div
                    className={`edit-assessment-question-footer__actions 
                    ${
                        currentGroup?.groupId === CONSTANT.ASSESSMENT_GROUP.CHIEF_COMPLAINTS.key &&
                        currentSubGroupQuestions && currentSubGroupQuestions.length === 0 && 
                        (!isMobile) 
                            ? 
                              '' 
                            : 'edit-assessment-question-footer__actions--mt-15'
                    }`}
                >
                    <div className="edit-assessment-question-footer__button-container">
                        <div className={"edit-assessment-question-footer__button-container"}>
                            {
                                !(
                                    currentGroupIndex === 0 &&
                                    (currentSubGroupIndex === 0 || subGroups.length === 0)
                                ) && (
                                    <button
                                        className="edit-assessment-question-footer__button edit-assessment-question-footer previous-button"
                                        onClick={handleOnClickPrevBtn}
                                    >
                                        <i className="fa fa-angle-left edit-assessment-question-footer__icon--left"/>
                                        Previous
                                    </button>
                                )
                            }

                            {(currentGroupIndex !== groups.length - 1) &&
                                (
                                    <button
                                        className={`edit-assessment-question-footer__button edit-assessment-question-footer next-button`}
                                        onClick={handleOnClickNextBtn}
                                    >
                                        Next
                                        <i className="fa fa-angle-right edit-assessment-question-footer__icon--right"/>
                                    </button>
                                )
                            }
                        </div>
                        {groupIdsWillHaveSubmitBtn.includes(currentGroupId) && (
                            <button
                                className={`edit-assessment-question-footer__button edit-assessment-question-footer__button--submit edit-assessment-question-footer__submit-button-wrapper`}
                                disabled={isReportAvailable}
                                onClick={handleOnClickSubmit}
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default EditAssessmentQuestionFooter;
